<section id="navigation">
    <header  class="header">   
        <nav style="background-color: #19b2e2; color: #f1f1f1;"  class="navbar navbar-expand-lg">
          <div class="search-panel">
            <div class="search-inner d-flex align-items-center justify-content-center">
              <div class="close-btn">Close <i class="fa fa-close"></i></div>
              <form id="searchForm" action="#">
                <div class="form-group">
                  <input type="search" name="search" placeholder="What are you searching for...">
                  <button type="submit" class="submit">Search</button>
                </div>
              </form>
            </div>
          </div>
          <div class="container-fluid d-flex align-items-center justify-content-between">
            <div class="navbar-header">
              <!-- Navbar Header--><a routerLink="/myboard" class="navbar-brand">
                <!-- <div class="brand-text brand-big visible text-uppercase"><strong class="text-primary">Dark</strong><strong>Admin</strong></div>
                <div class="brand-text brand-sm"><strong class="text-primary">D</strong><strong>A</strong></div></a> -->
                <div class="brand-text brand-big visible text-uppercase align-items-center"><img src="/assets/t-logo.png" style="width: 60px;height: 60px; border-radius: 100%" class="d-inline-block img-thumbnail align-top" alt="" srcset=""/> <strong class="pl-2">THRIVELY</strong> </div>
                <div class="brand-text  brand-sm">
                 <img src="/assets/logo.png" style="width: 50px;height: 50px; border-radius: 100%" class="d-inline-block img-thumbnail align-top" alt="" srcset=""/>
                  
                 </div>
                </a>
                
              <!-- Sidebar Toggle Btn-->
              <!-- <button class="sidebar-toggle"><i class="fa fa-long-arrow-left"></i></button> -->
            </div>
            <div class="right-menu list-inline no-margin-bottom">    
                <div class=" mobile-menu list-inline-item dropdown">
                    <a id="languages" rel="nofollow" routerLink="home" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link language dropdown-toggle">
                      <!-- <img src="/assets/user.jpg" style="width: 5vh; border-radius: 100%;" alt="English"> -->
                      <span class=" d-sm-inline-block">Menu</span>
                    </a>
                    <div aria-labelledby="languages" style="width: 5vh !important;" class="dropdown-menu">
    
                        <!-- <nav id="sidebar" > -->
                       
                            <a rel="nofollow" routerLink="home" class="dropdown-item"> <i class="icon-home pr-4"></i> Dashboard </a>
                            <a rel="nofollow" routerLink="wallet" class="dropdown-item"> <i class="icon-bill pr-4"></i> My Wallet</a>   
                            <a  rel="nofollow"routerLink="myprofile" class="dropdown-item"> <i class="fa fa-user pr-4"></i> My Profile </a> 
                            <a rel="nofollow" routerLink="txns" class="dropdown-item"> <i class="icon-padnote pr-4"></i> Thrift Trasactions </a>    
                            <!-- <li><a href="#exampledropdownDropdown" aria-expanded="false" data-toggle="collapse"> <i class="icon-windows"></i>Example dropdown </a>
                              <ul id="exampledropdownDropdown" class="collapse list-unstyled ">
                                <li><a href="#">Page</a></li>
                                <li><a href="#">Page</a></li>
                                <li><a href="#">Page</a></li>
                              </ul>
                            </li> -->
                            <a rel="nofollow" routerLink="settings" class="dropdown-item pr-4"> <i class="icon-settings pr-4"></i> Settings </a> 
                    
                      <a href="#" class="dropdown-item"> <i class="fa fa-bank pr-4"></i> My Organization </a>
                      <a routerLink="payment-details" class="dropdown-item"> <i class="fa fa-credit-card-alt pr-4"></i> Payment Details</a>
                      <a href="#" class="dropdown-item"> <i class="icon-light-bulb pr-4"></i> Membership </a>
                      <a href="#" class="dropdown-item"> <i class="icon-chart pr-4"></i> Upcoming Feature </a>
                      <a routerLink="verify-me" class="dropdown-item"> <i class="fa fa-bank pr-4"></i> Verify Account</a>
                     <a id="logout" (click)="clearAll()" class="dropdown-item"> <i class="icon-logout pr-4"></i> Logout </a>
                    
                    <!-- </nav> -->
    
                        <!-- Menu End -->
                      <a rel="nofollow" href="#" class="dropdown-item"> 
                        <img src="/assets/user.jpg" style="width: 5vh; border-radius: 100%;"  alt="English" class="mr-2"><span>Become a Thrift Collector</span>
                      </a>
                        <a rel="nofollow" href="#" class="dropdown-item">
                           <img src="/assets/user.jpg" style="width: 5vh; border-radius: 100%;" alt="English" class="mr-2"><span>Create an Organization </span>
                          </a>
                          <a rel="nofollow" type="button" data-toggle="modal" data-target="#joinThrift" class="dropdown-item">
                            <img src="/assets/user.jpg" style="width: 5vh; border-radius: 100%;" alt="English" class="mr-2"><span>Join A Thrift </span>
                           </a>
                          </div>
                  </div>
              <div class="list-inline-item"><a href="#" class="search-open nav-link"><i class="icon-magnifying-glass-browser"></i></a></div>

              
              <div class="list-inline-item dropdown"><a id="navbarDropdownMenuLink1" href="http://example.com" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link messages-toggle"><i class="icon-email"></i><span class="badge dashbg-1">{{notifyLength}}</span></a>
                <div aria-labelledby="navbarDropdownMenuLink1" class="dropdown-menu messages">
                  <!-- Messages -->
                  <a type="button" *ngFor="let notification of notifications;" class="dropdown-item message d-flex align-items-center">
                    <div class="profile"><img src="/assets/notify.png" alt="..." class="img-fluid">
                      <div class="status online"></div>
                    </div>
                    <div class="content"> 
                        <strong class="d-block">Message Title</strong>
                        <span class="d-block"> {{notification?.message}} </span>
                        <small class="date d-block">{{notification?.time}} <i class="fa fa-circle"></i> {{notification?.date}}</small></div>
                      </a>

                      <!-- Message element end -->
                      
                      <!-- Messages -->
               

                      <!-- Message element end -->
                  
                  </div>
              </div>


              <!-- Tasks-->
              <div class="list-inline-item dropdown"><a id="navbarDropdownMenuLink2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link tasks-toggle"><i class="icon-new-file"></i><span class="badge dashbg-3">9</span></a>
                <div aria-labelledby="navbarDropdownMenuLink2" class="dropdown-menu tasks-list">
                  <a href="#" class="dropdown-item">
                    <div class="text d-flex justify-content-between"><strong>NCS Cooperative</strong><span>40% complete</span></div>
                    <div class="progress">
                      <div role="progressbar" style="width: 40%" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" class="progress-bar dashbg-1"></div>
                    </div></a>
                    
                    <a href="#" class="dropdown-item">
                    <div class="text d-flex justify-content-between"><strong>FUNAAB ASUU Cooperative</strong><span>20% complete</span></div>
                    <div class="progress">
                      <div role="progressbar" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" class="progress-bar dashbg-3"></div>
                    </div></a>
                    
                   
                </div>
              </div>
              <!-- Tasks end-->
              <!-- Megamenu-->
              <!-- <div class="list-inline-item dropdown menu-large"><a href="#" data-toggle="dropdown" class="nav-link">Mega <i class="fa fa-ellipsis-v"></i></a>
                <div class="dropdown-menu megamenu">
                  <div class="row">
                    <div class="col-lg-3 col-md-6"><strong class="text-uppercase">Elements Heading</strong>
                      <ul class="list-unstyled mb-3">
                        <li><a href="#">Lorem ipsum dolor</a></li>
                        <li><a href="#">Sed ut perspiciatis</a></li>
                        <li><a href="#">Voluptatum deleniti</a></li>
                        <li><a href="#">At vero eos</a></li>
                        <li><a href="#">Consectetur adipiscing</a></li>
                        <li><a href="#">Duis aute irure</a></li>
                        <li><a href="#">Necessitatibus saepe</a></li>
                        <li><a href="#">Maiores alias</a></li>
                      </ul>
                    </div>
                    <div class="col-lg-3 col-md-6"><strong class="text-uppercase">Elements Heading</strong>
                      <ul class="list-unstyled mb-3">
                        <li><a href="#">Lorem ipsum dolor</a></li>
                        <li><a href="#">Sed ut perspiciatis</a></li>
                        <li><a href="#">Voluptatum deleniti</a></li>
                        <li><a href="#">At vero eos</a></li>
                        <li><a href="#">Consectetur adipiscing</a></li>
                        <li><a href="#">Duis aute irure</a></li>
                        <li><a href="#">Necessitatibus saepe</a></li>
                        <li><a href="#">Maiores alias</a></li>
                      </ul>
                    </div>
                    <div class="col-lg-3 col-md-6"><strong class="text-uppercase">Elements Heading</strong>
                      <ul class="list-unstyled mb-3">
                        <li><a href="#">Lorem ipsum dolor</a></li>
                        <li><a href="#">Sed ut perspiciatis</a></li>
                        <li><a href="#">Voluptatum deleniti</a></li>
                        <li><a href="#">At vero eos</a></li>
                        <li><a href="#">Consectetur adipiscing</a></li>
                        <li><a href="#">Duis aute irure</a></li>
                        <li><a href="#">Necessitatibus saepe</a></li>
                        <li><a href="#">Maiores alias</a></li>
                      </ul>
                    </div>
                    <div class="col-lg-3 col-md-6"><strong class="text-uppercase">Elements Heading</strong>
                      <ul class="list-unstyled mb-3">
                        <li><a href="#">Lorem ipsum dolor</a></li>
                        <li><a href="#">Sed ut perspiciatis</a></li>
                        <li><a href="#">Voluptatum deleniti</a></li>
                        <li><a href="#">At vero eos</a></li>
                        <li><a href="#">Consectetur adipiscing</a></li>
                        <li><a href="#">Duis aute irure</a></li>
                        <li><a href="#">Necessitatibus saepe</a></li>
                        <li><a href="#">Maiores alias</a></li>
                      </ul>
                    </div>
                  </div>
                  <div class="row megamenu-buttons text-center">
                    <div class="col-lg-2 col-md-4"><a href="#" class="d-block megamenu-button-link dashbg-1"><i class="fa fa-clock-o"></i><strong>Demo 1</strong></a></div>
                    <div class="col-lg-2 col-md-4"><a href="#" class="d-block megamenu-button-link dashbg-2"><i class="fa fa-clock-o"></i><strong>Demo 2</strong></a></div>
                    <div class="col-lg-2 col-md-4"><a href="#" class="d-block megamenu-button-link dashbg-3"><i class="fa fa-clock-o"></i><strong>Demo 3</strong></a></div>
                    <div class="col-lg-2 col-md-4"><a href="#" class="d-block megamenu-button-link dashbg-4"><i class="fa fa-clock-o"></i><strong>Demo 4</strong></a></div>
                    <div class="col-lg-2 col-md-4"><a href="#" class="d-block megamenu-button-link bg-danger"><i class="fa fa-clock-o"></i><strong>Demo 5</strong></a></div>
                    <div class="col-lg-2 col-md-4"><a href="#" class="d-block megamenu-button-link bg-info"><i class="fa fa-clock-o"></i><strong>Demo 6</strong></a></div>
                  </div>
                </div>
              </div> -->
              <!-- Megamenu end     -->
              <!-- Languages dropdown    -->
              <div class="desktop-menu list-inline-item dropdown">
                <a id="languages" rel="nofollow" data-target="#" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link language dropdown-toggle">
                  <img src="/assets/user.jpg" style="width: 5vh; border-radius: 100%;" alt="English">
                  <span class="d-none d-sm-inline-block">User Action</span>
                </a>
                <div aria-labelledby="languages" class="dropdown-menu">
                  <a rel="nofollow" routerLink="thrift-board" class="dropdown-item"> 
                    <img src="/assets/user.jpg" style="width: 5vh; border-radius: 100%;"  alt="English" class="mr-2"><span>Become a Thrift Collector</span>
                  </a>
                    <a rel="nofollow" routerLink="/myboard/organization" class="dropdown-item">
                       <img src="/assets/user.jpg" style="width: 5vh; border-radius: 100%;" alt="English" class="mr-2"><span>Create an Organization </span>
                      </a>
                      <a rel="nofollow" type="button" data-toggle="modal" data-target="#joinThrift" class="dropdown-item">
                        <img src="/assets/user.jpg" style="width: 5vh; border-radius: 100%;" alt="English" class="mr-2"><span>Join A Thrift </span>
                       </a>
                      </div>
              </div>
          
              <!-- Log out               -->
              <div class="desktop-menu list-inline-item logout">                   <a id="logout" style="cursor: pointer;" (click)="clearAll()" class="nav-link"> <i class="icon-logout"></i>Logout </a></div>
            </div>
          </div>
        </nav>
      </header>
</section>



<app-notification-modal></app-notification-modal>
<app-join-thrift></app-join-thrift>
<app-transfer-funds-internally></app-transfer-funds-internally>
<app-fund-wallet></app-fund-wallet>